export const baseUrl = process.env.NODE_ENV === "production" ? "/server/" : "http://localhost:3000/server/";
